<!--
 * @FileDescription: 已出账
 * @Author: 陈文景
 * @Date: 2022-12-27 09:34:13
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <PageSkeletonTabs>
    <template slot="header-left">
      <el-select v-model="parameter.userGroups" multiple collapse-tags filterable clearable size="medium" placeholder="请选择用户类型" @change="getAdminBilleds">
        <el-option v-for="item in userTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <el-select v-model="parameter.paymentStatusList" multiple collapse-tags filterable clearable size="medium" placeholder="请选择支付状态" @change="getAdminBilleds">
        <el-option v-for="item in paymentStatusListOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>

      <div class="select-picker">
        <el-select v-model="parameter.dateType" size="medium" placeholder="请选择" @change="onSelectDateType">
          <el-option label="付款时间" :value="1" />
          <el-option label="创建时间" :value="2" />
        </el-select>
        <el-date-picker v-model="parameter.dateTime" size="medium" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="changeDatePicker" />
      </div>

      <BatchSearch :option="searchConditionOptins" :selected="parameter.searchType" @select="searchType" @search="search" @clear="clear" />

      <el-button @click="dataExport" style="height: 36px; margin-left: 10px">数据导出</el-button>
    </template>

    <template slot="container">
      <el-table v-loading="loading" :data="bills" size="medium" row-key="id" :style="{ width: `${tableWidth}%` }" :height="`${tableHeight}%`" @sort-change="onTableSortChange">
        <el-table-column prop="billId" label="账单号" show-overflow-tooltip />
        <el-table-column prop="email" label="邮箱/手机号" show-overflow-tooltip>
          <template slot-scope="{row}">
              <div>{{ row.email }}</div>
              <div>{{ row.phone }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="应收款(USD)" show-overflow-tooltip sortable="custom">
          <template v-slot="{ row }">
            {{ amount(row.amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="paidAmount" label="已付款(USD)" show-overflow-tooltip sortable="custom">
          <template v-slot="{ row }">
            {{ paidAmount(row.paidAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="用户类型" show-overflow-tooltip>
          <template v-slot="{ row }">
            {{ userGroup(row.userGroup) }}
          </template>
        </el-table-column>
        <el-table-column prop="paymentDate" label="付款时间" show-overflow-tooltip sortable="custom">
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.paymentDate)) }}
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" show-overflow-tooltip sortable="custom">
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.createDate)) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" show-overflow-tooltip>
          <template v-slot="{ row }">
            {{ paymentStatus(row.paymentStatus) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" show-overflow-tooltip align="center" width="100">
          <template v-slot="{ row }">
            <el-button type="text" size="medium" @click="() => checkDetails(row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #footer-right>
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="sizeChange" @current-change="currentChange" />
    </template>

    <!-- 详情对话框 -->
    <BillDetailsDialog ref="billDetails" />
    <!-- 账期导出对话框 -->
    <BillExport ref="billExport" :parameter="parameter" />
  </PageSkeletonTabs>
</template>

<script>
import API from '@/api'
import BillDetailsDialog from './BillDetailsDialog.vue'
import PageSkeletonTabs from './PageSkeletonTabs.vue'
import BatchSearch from '@/components/BatchSearch.vue'
import { formatTimeStamp } from '@/utils/moment'
import BillExport from './BillExport.vue'

let parameter = {
  userGroups: [], // 用户类型数组
  paymentStatusList: [], // 付款状态数组
  dateTime: undefined, // 时间选择器双向绑定的值(请求前需删除该字段)
  dateType: 1, // 选择的时间类型(请求前需删除该字段)
  paymentDateStart: undefined, // 付款时间-开始
  paymentDateEnd: undefined, // 付款时间-截止
  createDateStart: undefined, // 创建时间-开始
  createDateEnd: undefined, // 创建时间-截止
  searchType: 2, // 批量搜索的条件(请求前需删除该字段)
  emails: [], // 用户邮箱数组
  billIds: [], // 账单ID数组
  sortType: undefined, // 排序类型: 1.应收款 2.已收款 3.账单支付时间 4.创建时间(为空则按更新时间降序)
  sort: undefined, // 升降序排序: asc.升序 desc.降序
  pageSize: 20,
  pageNumber: 1
}

export default {
  components: {
    BatchSearch,
    PageSkeletonTabs,
    BillDetailsDialog,
    BillExport
},
  data() {
    return {
      formatTimeStamp,

      tableWidth: 100,
      tableHeight: 100,

      // 用户类型下拉选项
      userTypeOptions: [
        { label: '独立站', value: 100 },
        { label: '默认', value: -1 }
      ],

      // 支付状态下拉选项
      paymentStatusListOptions: [
        { label: '待付款', value: 0 },
        { label: '付款中', value: 1 },
        { label: '已付款', value: 2 },
        { label: '支付失败', value: -2 }
      ],

      // 根据条件类型搜索下拉选项
      searchConditionOptins: [
        { label: '账单号', value: 1 },
        { label: '邮箱/手机号', value: 2 }
      ],

      parameter: { ...parameter },
      total: 0, // 权限列表总数量
      loading: false,
      bills: []
    }
  },
  computed: {
    amount() {
      return (value) => {
        return value ? `US$${value}` : '-'
      }
    },
    paidAmount() {
      return (value) => {
        return value ? `US$${value}` : '-'
      }
    },
    userGroup() {
      return (value) => {
        switch (value) {
          case -1:
            return '默认'
          case 100:
            return '独立站'
          default:
            return '-'
        }
      }
    },
    paymentStatus() {
      return (value) => {
        switch (value) {
          case -2:
            return '支付失败'
          case 0:
            return '待付款'
          case 1:
            return '付款中'
          case 2:
            return '已付款'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    this.getAdminBilleds()
  },
  activated() {
    this.getAdminBilleds()
  },
  methods: {
    /**
     * API 获取权限列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getAdminBilleds(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let parameter = { ...this.parameter }
        delete parameter.dateType
        delete parameter.dateTime
        delete parameter.searchType
        let { data } = await API.getAdminBilleds(parameter)
        this.total = data.total
        this.bills = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 选择日期筛选类型
     *
     * @param {Number} value 当前选中的类型
     */
    onSelectDateType(value) {
      if (this.parameter.dateTime) {
        // 付款时间
        if (value === 1) {
          this.parameter.paymentDateStart = this.parameter.createDateStart
          this.parameter.paymentDateEnd = this.parameter.createDateEnd
          this.parameter.createDateStart = undefined
          this.parameter.createDateEnd = undefined
        }
        // 创建时间
        if (value === 2) {
          this.parameter.createDateStart = this.parameter.paymentDateStart
          this.parameter.createDateEnd = this.parameter.paymentDateEnd
          this.parameter.paymentDateStart = undefined
          this.parameter.paymentDateEnd = undefined
        }
        this.getAdminBilleds()
      }
    },

    /**
     * 时间日期选择器的回调事件
     *
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        // 付款时间
        if (this.parameter.dateType === 1) {
          this.parameter.paymentDateStart = date[0]
          this.parameter.paymentDateEnd = date[1]
          this.parameter.createDateStart = undefined
          this.parameter.createDateEnd = undefined
        }
        // 创建时间
        if (this.parameter.dateType === 2) {
          this.parameter.createDateStart = date[0]
          this.parameter.createDateEnd = date[1]
          this.parameter.paymentDateStart = undefined
          this.parameter.paymentDateEnd = undefined
        }
      } else {
        this.parameter.paymentDateStart = undefined
        this.parameter.paymentDateEnd = undefined
        this.parameter.createDateStart = undefined
        this.parameter.createDateEnd = undefined
      }
      this.getAdminBilleds()
    },

    /**
     * 选择搜索类型的回调
     *
     * @param {String} value 当前选中的值
     */
    searchType(value) {
      this.parameter.searchType = value
    },

    /**
     * 搜索按钮触发的回调
     *
     * @param {String} value
     */
    search(value) {
      // 账单号
      if (this.parameter.searchType === 1) {
        this.parameter.billIds = value ? value.split(',').map((item) => item.trim()) : []
        this.parameter.emails = []
      }
      // 用户邮箱
      if (this.parameter.searchType === 2) {
        this.parameter.emails = value ? value.split(',').map((item) => item.trim()): []
        this.parameter.billIds = []
      }
      this.getAdminBilleds()
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    clear() {
      this.parameter.emails = []
      this.parameter.billIds = []
      this.getAdminBilleds()
    },

    /**
     * 当表格的排序条件发生变化的时候会触发该事件
     *
     * @param {Object} value 排序对象
     */
    onTableSortChange({ prop, order }) {
      this.parameter.sortType = prop === 'amount' ? 1 : prop === 'paidAmount' ? 2 : prop === 'paymentDate' ? 3 : prop === 'createDate' ? 4 : undefined
      this.parameter.sort = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined
      this.getAdminBilleds()
    },

    /**
     * 查看详情
     *
     * @param {Object} row 当前行数据
     */
    checkDetails(row) {
      this.$refs.billDetails.show(row)
    },
    /**
     * 展示导出对话框
     */
    dataExport() {
      this.$refs.billExport.show()
    },
    /**
     * 每页显示条数发生改变时的回调
     *
     * @param {Number} size 每页显示条数
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getAdminBilleds(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param {Number} current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getAdminBilleds(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-picker {
  display: inline-block;
  .el-select {
    width: 108px;
    /deep/.el-input__inner {
      border-right: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .el-range-editor.el-input__inner {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
</style>
